import React from "react";
import Slider from "react-slick/lib";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Accordion, Card } from "react-bootstrap";
import * as CONFIG from "./_config";
import Iframe from "react-iframe";
import { Helmet } from "react-helmet";
import ls from "local-storage";
import FirstchoiceAbout from "./firstchoice_about";

const axios = require("axios");

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.About();
      this.Getlocation();
    }
  }

  componentDidMount() {
    this.About();
    this.Getlocation();
  }

  formatPhoneNumber(phoneNumberString) {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = match[1] ? "+1 " : "";
      return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
    }
    return "";
  }

  Getlocation() {
    if (CONFIG.DATA.BACKEND_HOST !== "eldens") {
      this.setState({ stores: [] });
      return;
    }

    var ClientStores = ls.get("ClientStores");
    // console.log("storage", ClientStores);

    if (ClientStores) {
      this.setState({ stores: ClientStores });
    } else {
      const data = new FormData();
      data.append("method", "POST");
      var apiurl;
      if (CONFIG.DATA.LOAD_STORE_FROM_DIFFERENT_URL) {
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`;
        //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`);
      } else {
        // data.append(
        //   "apiurl",
        //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetClientStores/1`
        // );
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetClientStores/1`;
      }
      var object = {};
      data.forEach((value, key) => (object[key] = value));
      var jsonData = JSON.stringify(object);

      axios
        .post(apiurl, jsonData, {
          headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
        })

        .then((res) => {
          this.setState({ stores: res.data.GetClientStores });
          // console.log("stores", this.state.stores);
        })
        .catch(function (response) {
          console.log(response);
        });
    }
  }

  About = () => {
    var about_menu = CONFIG.DATA.MENU.find((x) => x.menu_url === "/about");
    const about_submenu = about_menu.submenu.find(
      (x) => x.submenu_url === this.props.match.url
    );

    this.setState({
      about_menu: about_menu,
      about_submenu: about_submenu,
    });
  };

  render() {
    const about_menu = this.state.about_menu;
    const about_submenu = this.state.about_submenu;

    // console.log(about_menu, about_submenu);

    if (!about_menu && !about_submenu)
      return (
        <div style={{ textAlign: "left", minHeight: "600px" }}>
          <div className="content">
            <div className="overlay">
              <div className="overlay-content">
                <img
                  style={{ maxWidth: "none" }}
                  src="/assets/images/loading.gif"
                  alt="Loading..."
                />
              </div>
            </div>
          </div>
        </div>
      );

    var Name =
      this.props.match.params.page ||
      (about_submenu ? about_submenu.submenu_name : about_menu.menu_name);
    Name = Name.replace(/-/g, " ");

    return (
      <div className="main-container full-width pt-5 mt-5">
        <Helmet>
          <meta name="title" content="cashsaver"></meta>
          <meta
            name="description"
            content="Your Hometown Grocery Store!"
          ></meta>
          <meta
            name="keywords"
            content="cashsaver,cupones,sho,online,products"
          ></meta>
          <meta name="robots" content="index, follow"></meta>
          <meta
            http-equiv="Content-Type"
            content="text/html; charset=utf-8"
          ></meta>
          <meta name="language" content="English"></meta>
        </Helmet>
        <section
          id="apus-breadscrumb"
          className="breadcrumb-page apus-breadscrumb"
          style={{ backgroundColor: "#f3ffd9" }}
        >
          <div className="container">
            <div className="wrapper-breads">
              <div className="wrapper-breads-inner">
                <div className="breadscrumb-inner">
                  <h2 className="bread-title">{Name}</h2>
                  <ol className="breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <span className="active">{Name}</span>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="container">
          {CONFIG.DATA.RSA_SUBDOMAIN === "firstchoicemarket" ? (
            <>
              <FirstchoiceAbout />
            </>
          ) : (
            <>
              <div
                className="row abou_us_page about-page"
                style={{ marginLeft: "0px", marginRight: "0px" }}
              >
                <div className="vc_empty_space" style={{ height: "35px" }}>
                  <span className="vc_empty_space_inner"></span>
                </div>
                {about_submenu ? (
                  <div className="wpb_column vc_column_container vc_col-sm-10">
                    <div className="vc_column-inner">
                      <div className="wpb_wrapper">
                        <div className="row">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: about_submenu.submenu_html_text,
                            }}
                          ></div>
                        </div>
                        <div className="row">
                          <div
                            className="col-md-12 text-left aboutus_page"
                            style={{ paddingLeft: "0px", paddingRight: "0px" }}
                          >
                            {about_submenu.submenu_list ? (
                              <Accordion defaultActiveKey={0}>
                                {about_submenu.submenu_list.map((val, key) => (
                                  <Card key={key}>
                                    <Accordion.Toggle
                                      as={Card.Header}
                                      eventKey={key}
                                    >
                                      {val.name}
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey={key}>
                                      <Card.Body>
                                        <div className="container">
                                          <div className="row">
                                            <div className="col-md-3">
                                              <img
                                                alt="Store"
                                                src={val.image_url}
                                              />
                                            </div>
                                            <div className="col-md-9">
                                              <div>
                                                <p style={{ fontSize: "12pt" }}>
                                                  {val.text}
                                                </p>
                                              </div>
                                              {val.button !== "" ? (
                                                <div>
                                                  <a
                                                    className=""
                                                    href={val.link}
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                  >
                                                    {val.button}
                                                  </a>
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </Card.Body>
                                    </Accordion.Collapse>
                                  </Card>
                                ))}
                              </Accordion>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {about_submenu ? (
                  ""
                ) : (
                  <div className="vc_row wpb_row vc_inner vc_row-fluid">
                    <div className="wpb_column vc_column_container vc_col-sm-12">
                      <div className="vc_column-inner">
                        <div className="wpb_wrapper">
                          <div className="widget widget-text-heading  default">
                            <>
                              <h3 className="title">
                                Welcome{" "}
                                {CONFIG.DATA.BACKEND_HOST === "prengerfoods"
                                  ? "Home"
                                  : ""}{" "}
                                to {CONFIG.DATA.RSA_CLIENT_APP_NAME}
                              </h3>

                              <div
                                className="description font-size-17px"
                                style={{ color: "#000" }}
                              >
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: CONFIG.DATA.ABOUT_US_DESCRIPTION,
                                  }}
                                ></span>
                              </div>
                            </>
                          </div>

                          <div
                            className="vc_empty_space"
                            style={{ height: "30px" }}
                          >
                            <span className="vc_empty_space_inner"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {about_menu &&
                !about_submenu &&
                CONFIG.DATA.ABOUT_US_EXTRA_DESC !== "" &&
                CONFIG.DATA.ABOUT_US_EXTRA_DESC !== "<p><br></p>" ? (
                  <div
                    className="section-bg "
                    style={{ padding: "0px", color: "#000" }}
                  >
                    <div className="container-fluid">
                      <div className="row">
                        {CONFIG.DATA.STORE_IMAGE2 !== "" ? (
                          <React.Fragment>
                            <div
                              className="col-lg-3"
                              style={{ padding: "0px" }}
                            >
                              <img
                                loading="lazy"
                                alt={CONFIG.DATA.STORE_IMAGE2_ALT_TEXT}
                                src={CONFIG.DATA.STORE_IMAGE2}
                                style={
                                  {
                                    /* maxHeight: 411, objectFit: 'cover'*/
                                  }
                                }
                                className="img-response"
                              />
                            </div>
                            <div className="about_us wpb_column vc_column_container vc_col-sm-12 vc_col-lg-9 vc_col-md-9">
                              <div className="wpb_wrapper">
                                <div className="widget widget-features-box  ">
                                  <div className="content">
                                    <p
                                      style={{ fontSize: "14px" }}
                                      dangerouslySetInnerHTML={{
                                        __html: CONFIG.DATA.ABOUT_US_EXTRA_DESC,
                                      }}
                                    ></p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        ) : (
                          ""
                        )}
                        <div className="about_us wpb_column vc_column_container vc_col-sm-12 vc_col-lg-12 vc_col-md-12">
                          <div className="wpb_wrapper">
                            <div className="widget widget-features-box  ">
                              <div className="content">
                                <p
                                  style={{ fontSize: "14px" }}
                                  dangerouslySetInnerHTML={{
                                    __html: CONFIG.DATA.ABOUT_US_EXTRA_DESC,
                                  }}
                                ></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="vc_empty_space" style={{ height: "35px" }}>
                      <span className="vc_empty_space_inner"></span>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {about_submenu ? (
                  ""
                ) : (
                  <div
                    className="section-bg style-1"
                    style={{ padding: "0px" }}
                  >
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-lg-6" style={{ padding: "0px" }}>
                          <img
                            loading="lazy"
                            alt={CONFIG.DATA.STORE_IMAGE_ALT_TEXT}
                            src={CONFIG.DATA.STORE_IMAGE}
                            style={
                              {
                                /* maxHeight: 411, objectFit: 'cover'*/
                              }
                            }
                            className="img-response"
                          />
                        </div>

                        <div className="about_us wpb_column vc_column_container vc_col-sm-12 vc_col-lg-6 vc_col-md-12">
                          <div className="vc_column-inner">
                            <div className="wpb_wrapper">
                              <div className="widget widget-features-box  ">
                                <div className="content">
                                  <div className="feature-box-inner clearfix">
                                    <div className="fbox-icon">
                                      <i className="fa fa-heart"></i>
                                    </div>
                                    <div className="fbox-content ">
                                      {
                                        CONFIG.DATA.BACKEND_HOST ===
                                        "grocerydepotms" ? (
                                          <h3 className="ourservice-heading">
                                            {" "}
                                            Great Shopping Experience
                                          </h3>
                                        ) : (
                                          <h3 className="ourservice-heading">
                                            {" "}
                                            Great Shopping Experience
                                          </h3>
                                        )

                                        // <h3 className="ourservice-heading"> 100% Customer Satisfaction</h3>
                                      }

                                      <div className="description font-size-17px">
                                        To give our customers the best quality
                                        products and services at competitive
                                        prices in pleasant and safe conditions
                                      </div>
                                    </div>
                                  </div>
                                  <div className="feature-box-inner clearfix">
                                    <div className="fbox-icon">
                                      <i className="fa fa-gift"></i>
                                    </div>
                                    <div className="fbox-content ">
                                      <h3 className="ourservice-heading">
                                        Enjoyable Work Environment
                                      </h3>
                                      <div className="description font-size-17px">
                                        To provide our associates and employees
                                        a safe and enjoyable work environment
                                        while providing competitive wage and
                                        benefit compensation.
                                      </div>
                                    </div>
                                  </div>
                                  <div className="feature-box-inner clearfix">
                                    <div className="fbox-icon">
                                      <i className="fa fa-group"></i>
                                    </div>
                                    <div className="fbox-content ">
                                      <h3 className="ourservice-heading">
                                        Community Projects
                                      </h3>
                                      <div className="description font-size-17px">
                                        Our stores participate in our local
                                        Chambers of Commerce and our managers
                                        are members of local clubs and
                                        organizations.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {about_submenu ? (
                  ""
                ) : CONFIG.DATA.BACKEND_HOST === "eldens" ? (
                  <div className="vc_col-xs-12">
                    <div className="vc_empty_space" style={{ height: "50px" }}>
                      <span className="vc_empty_space_inner"></span>
                    </div>
                    <div className="page-content default-page">
                      {!this.state.stores ? (
                        <div style={{ textAlign: "left", minHeight: "600px" }}>
                          <div className="content">
                            <div className="overlay">
                              <div className="overlay-content">
                                <img
                                  style={{ maxWidth: "none" }}
                                  src="/assets/images/loading.gif"
                                  alt="Loading..."
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <article className="post-8436 page type-page status-publish hentry">
                          <div className="entry-content">
                            <div className="vc_row wpb_row vc_row-fluid">
                              <div
                                className="row-container"
                                style={{
                                  /* marginLeft:'25%',*/ marginTop: "25px",
                                }}
                              >
                                {this.state.stores.map((val, index) => {
                                  return (
                                    <div key={index} className="row">
                                      <div className="col-md-4 address">
                                        <h2>
                                          {
                                            //val.City
                                            CONFIG.DATA.RSA_CLIENT_APP_NAME
                                          }
                                        </h2>
                                        <p
                                          style={{
                                            marginBottom: "-4px",
                                          }}
                                        >
                                          {val.AddressLine1}
                                        </p>
                                        <p style={{ marginBottom: "-4px" }}>
                                          {val.City +
                                            ", " +
                                            val.AddressLine2 +
                                            " " +
                                            val.ZipCode}
                                        </p>
                                        <p style={{ marginBottom: "-4px" }}>
                                          <a
                                            href={"tel:" + val.StorePhoneNumber}
                                          >
                                            {this.formatPhoneNumber(
                                              val.StorePhoneNumber
                                            )}
                                          </a>
                                        </p>
                                        <p style={{ marginBottom: "-4px" }}>
                                          <a href={"mailto:" + val.StoreEmail}>
                                            {val.StoreEmail}
                                          </a>
                                        </p>
                                        <p style={{ marginBottom: "-4px" }}>
                                          <b>HOURS: </b>
                                          {val.StoreTimings}
                                        </p>
                                      </div>
                                      <div className="col-md-8">
                                        <Iframe
                                          style={{
                                            display: "block",
                                            width: "100%",
                                            border: "0px none",
                                          }}
                                          width="700"
                                          height="480"
                                          frameborder="0"
                                          allowfullscreen=""
                                          url={
                                            "https://maps.google.com/maps?q=" +
                                            val.Latitude +
                                            "," +
                                            val.Longitude +
                                            "&hl=es;z=14&output=embed"
                                          }
                                        ></Iframe>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </article>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="vc_empty_space" style={{ height: "50px" }}>
                    <span className="vc_empty_space_inner"></span>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}
export default withRouter(About);
